<template>
  <!--  -->
  <ModalDialog
    style="font-size: 14px"
    dialog-width="90%"
    dialog-height="auto"
    margin-class="mtp-3 mbm-3"
    pop-name="OCR読み込みファイル確認"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div class="mtp-3">
        <Pagination class="mbm-3" :list="list"></Pagination>
        <div class="d-flex justify-content-center">
          全{{ list.length }}ページ中1ページ目表示
        </div>
        <div
          v-for="(item, index) in list"
          v-show="edit"
          :key="index"
          class="mtp-1"
        >
          <div style="display: flex">
            <div
              class="border-start border-top border-end d-flex align-items-center"
              style="height: 25px; width: calc(13%)"
            >
              &nbsp;ファイル名
            </div>
            <div
              class="border-end border-top d-flex align-items-center"
              style="height: 25px; width: calc(37%)"
            >
              &nbsp;{{ item.name }}
            </div>

            <div
              class="d-flex align-items-center justify-content-end px-4"
              style="color: red; width: calc(50%); height: 25px"
            >
              <div
                :class="[
                  item.remark == '読取り完了' ? 'green' : '',
                  item.remark == '読取り中' ? 'red' : '',
                  item.remark == '読取り確認済' ? 'gray' : ''
                ]"
              >
                {{ item.remark }}
              </div>
            </div>
          </div>

          <textarea
            v-model="item.content"
            class="form-control"
            style="
              height: 570px;
              width: 100%;
              overflow: auto;
              text-align: center;
              line-height: 555px;
            "
            placeholder=""
          >
          </textarea>
        </div>

        <div
          v-for="(item, index) in list"
          v-show="!edit"
          :key="index"
          class="mtp-3"
        >
          <div style="display: flex">
            <div
              class="border-start border-top border-end d-flex align-items-center"
              style="height: 38px; width: calc(13%)"
            >
              &nbsp;ファイル名
            </div>
            <div
              class="border-end border-top d-flex align-items-center"
              style="height: 38px; width: calc(37%)"
            >
              &nbsp;{{ item.name }}
            </div>
          </div>

          <textarea
            v-model="item.content"
            class="form-control"
            style="
              text-align: center;
              line-height: 500px;
              height: 500px;
              width: 100%;
              overflow: auto;
            "
            placeholder=""
          ></textarea>
        </div>
      </div>
    </template>

    <template #footer>
      <div v-show="edit">
        <div class="d-flex justify-content-center">
          <ButtonMain button-name="全文テキスト更新"></ButtonMain>
          <ButtonMain
            class="ms-4"
            button-name="読取り確認"
            @click="check"
          ></ButtonMain>
          <ButtonNormal
            class="ms-4"
            button-name="キャンセル"
            @click="Cancel"
          ></ButtonNormal>
        </div>
      </div>
      <div v-show="!edit">
        <div class="d-flex justify-content-center">
          <ButtonMain button-name="閉じる"></ButtonMain>
        </div>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'CheckOCRReadFileDialog',
  props: {
    list: Array
  },
  data() {
    return {
      edit: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    check() {
      this.$emit('close')
    },
    Cancel() {
      this.$emit('close')
    },
    update() {
      this.edit = false
    }
  }
}
</script>
<style scoped lang="scss">
.green {
  color: green;
}

.red {
  color: red;
}

.gray {
  color: #999;
}
</style>
